


































import Vue from 'vue'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import { TranslateResult } from 'vue-i18n'
import Select from '@/components/additional-fields/AdditionalFieldsSelect.vue'
import NumberField from '@/components/additional-fields/AdditionalFieldsNumber.vue'
import FieldsText from '@/components/additional-fields/AdditionalFieldsText.vue'
import Check from '@/components/additional-fields/AdditionalFieldsCheck.vue'
import Textarea from '@/components/additional-fields/AdditionalFieldsTextArea.vue'
import Email from '@/components/additional-fields/AdditionalFieldsEmail.vue'
import FieldsDatePicker from '@/components/additional-fields/AdditionalFieldsDatePicker.vue'
import SelectMultiple from '@/components/additional-fields/AdditionalFieldsSelectMultiple.vue'
import { SnackbarStateEnum } from '@/types/enums'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { AdditionalFieldsPayloadItem, AdditionalFieldsProjectPayload } from '@/types/payload'
import {
  FETCH_PROJECT_ADDITIONAL_FIELDS,
  SAVE_PROJECT_ADDITIONAL
} from '@/store/action-types'
import DecimalNumber from '@/components/additional-fields/AdditionalFieldsDecimalNumber.vue'

interface ComponentData {
  active: number[]
  treeItemList: AdditionalGroup[] | null
  componentTypeMap: Map<number, string>
  selectedData: AdditionalFieldItem[]
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  noValid: number[]
}

export default Vue.extend({
  name: 'ProjectAdditionalFields',

  components: {
    Select,
    NumberField,
    FieldsText,
    Check,
    Textarea,
    Email,
    FieldsDatePicker,
    SelectMultiple,
    DecimalNumber
  },

  props: {
    projectId: Number
  },

  data (): ComponentData {
    return {
      active: [],
      treeItemList: [],
      componentTypeMap: new Map([
        [2, 'Select'], [4, 'DecimalNumber'], [1, 'FieldsText'], [21, 'Textarea'], [3, 'Check'], [6, 'Email'], [11, 'FieldsDatePicker'], [5, 'SelectMultiple']
      ]),
      selectedData: [],
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      noValid: []
    }
  },

  watch: {
    projectId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.treeItemList = []
        this.selectedData = []
        this.fetchAdditionalData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isSaveDisabled (): boolean {
      return this.noValid.length !== 0
    }
  },

  methods: {
    onValueChange (data: AdditionalFieldItem): void {
      if(data.componentId === 11) {
        if(data.value) {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          if (!pattern.test(data.value)) {
            if (!this.noValid.includes(data.parentType)) {
              this.noValid.push(data.parentType)
            }
          } else {
            if (this.noValid.includes(data.parentType)) {
              const index: number = this.noValid.indexOf(data.parentType)
              this.noValid.splice(index, 1)
            }
          }
        } else {
          if (this.noValid.includes(data.parentType)) {
            const index: number = this.noValid.indexOf(data.parentType)
            this.noValid.splice(index, 1)
          }
        }
      }

      const foundData: AdditionalFieldItem | undefined = this.selectedData.find((item: AdditionalFieldItem) => item.parentType === data.parentType)
      if(foundData) {
        const index: number = this.selectedData.indexOf(foundData)
        this.selectedData.splice(index, 1, data)
      } else {
        this.selectedData.push(data)
      }

      if(this.treeItemList) {
        this.treeItemList.forEach((group: AdditionalGroup) => {
          if (group.id === data.groupId) {
            group.children.forEach((field: AdditionalField, idx: number) => {
              if (field.type === data.parentType) {
                const updatedField: AdditionalField = AdditionalField.updateValue(field, data.value)
                group.children.splice(idx, 1, updatedField)
              }
            })
          }
        })
      }
    },

    onSaveButtonClick (): void {
      const fields: AdditionalFieldsPayloadItem[] = this.selectedData.map((item: AdditionalFieldItem) => {
        return {"Projekt": this.projectId, "Feldtyp": item.parentType, "Art": item.componentId, "Value": item.value}
      })

      const payload: AdditionalFieldsProjectPayload = {
        AdditionalFieldsForSaving: fields,
        ProjectId: this.projectId
      }
      this.saveAdditionalFields(payload)
    },

    async saveAdditionalFields (payload: AdditionalFieldsProjectPayload): Promise<void> {
      this.loading = true
      try {
        const response: boolean = await this.$store.dispatch(SAVE_PROJECT_ADDITIONAL, payload)
        this.selectedData = []
        this.loading = false
        if(response) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          await this.fetchAdditionalData()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchAdditionalData (): Promise<void> {
      this.treeItemList = await this.$store.dispatch(FETCH_PROJECT_ADDITIONAL_FIELDS, this.projectId)
      setTimeout(() => {
        const tree: any = this.$refs['tree']
        if(tree) {
          const firstElement = tree.$el.querySelector('.v-treeview-node__toggle--open')
          if (firstElement) {
            firstElement.focus()
          }
        }
      }, 0)
    }
  },

  mounted () {
    this.fetchAdditionalData()
  }
})
